/* eslint-disable no-mixed-operators */
/* eslint react/jsx-pascal-case: 0 */
/* eslint react/no-direct-mutation-state: 0 */
import * as React from "react";
import { Callout, DirectionalHint } from "@fluentui/react/lib/Callout";
import Search_HoverPanel from "./Search_HoverPanel";
import Helper from "../../../../core/libraries/Helper";
import Constants from "../../../../core/libraries/Constants";
import {
  IUserProfile,
} from "../../../Auth/types";
import {
  confirmDialog,
  showDialog,
  showToastMessage,
} from "../../../Dialog/actions";
import { RootState } from "../../../../store/store";
import { connect } from "react-redux";
import _ from "lodash";
import RbLabel, {
  LabelSize,
} from "../../../../bosch-react/components/label/RbLabel";
import RbLoadingSpinner from "../../../../bosch-react/components/loading-spinner/RbLoadingSpinner";
import { BoschColor } from "../../../../bosch-react/constants/color";
import RbButton, {
  ButtonType,
} from "../../../../bosch-react/components/button/RbButton";
import { addBookmark, removeMyBookmark } from "../../../Bookmark/services";
import { downloadReport, exportLLDocument } from "../../../../services/commonServices";
import { checkAccessibleReport } from "../../../AccessMediator/services";
import { ISearchResultItem, Search_ResultStates } from "../../types";
import Template from "../../../../core/libraries/Template";
import { getDisplayNameOfUsers } from "../../../../lib/graph";
import { IDownloadedStatistic, StatisticType, insertStatisticData } from "../../../Statistics/services";
import { deleteReportDispatch } from "../../../AccessMediator/thunks";
import { ToastMessageCode } from "../../../Dialog/types";
import { updateLLReferenceNumber } from '../../actions';

interface Search_ResultProps {
  userProfile: IUserProfile | undefined;
  confirmDialog: typeof confirmDialog;
  showDialog: typeof showDialog;
  showToastMessage: typeof showToastMessage;
  data: ISearchResultItem;
  deleteReportDispatch: any;
  updateLLReferenceNumber: typeof updateLLReferenceNumber;
}

class Search_Result extends React.Component<Search_ResultProps, Search_ResultStates> {

  constructor(props: Search_ResultProps) {
    super(props);

    this.state = {
      HasPermission: null,
      ItemRef: React.createRef(),
      IsHoverPanelDisplayed: false,
      IsMobileView: typeof window !== "undefined" ? window.matchMedia("(max-width: 768px)").matches : false,
      HoverStatuses: {
        item: false,
        panel: false,
      },
      Commands: [],
      IsAddingBookmark: false,
      IsExportLLDialogShown: false,
      IsDownloading: false,
      IsExportingLL: false,
      IsBookmarked: false,
    };

    this.checkShowAdminCommands = this.checkShowAdminCommands.bind(this);
    this.checkShowNormalCommands = this.checkShowNormalCommands.bind(this);

    this.checkPermissionInSessionStorage = this.checkPermissionInSessionStorage.bind(this);
    this.showHoverPanel = this.showHoverPanel.bind(this);
    this.openMobileHoverPanel = this.openMobileHoverPanel.bind(this);
    this.closeMobileHoverPanel = this.closeMobileHoverPanel.bind(this);
    this.onMobileViewChange = this.onMobileViewChange.bind(this);
    this.handleCommand = this.handleCommand.bind(this);

    this.renderCommandButtons = this.renderCommandButtons.bind(this);

    this._downloadFile = this._downloadFile.bind(this);
    this._askToRequestPermission = this._askToRequestPermission.bind(this);

    this.forwardEmail = this.forwardEmail.bind(this);
    this.addBookmark = this.addBookmark.bind(this);
    this.openRemoveBookmarkDialog = this.openRemoveBookmarkDialog.bind(this);
    this.removeBookmark = this.removeBookmark.bind(this);
    this.closeExportLLDialog = this.closeExportLLDialog.bind(this);
    this.closeDeleteReportDialog = this.closeDeleteReportDialog.bind(this);
  }

  checkIsBookmarked = (): boolean => {
    let bookmarksArr = Helper.getBookmarkArrayFromSession();
    return bookmarksArr.includes(Number.parseInt(this.props.data.Id))
  }

  async componentDidMount() {
    const { userProfile } = this.props
    this.setState({ IsBookmarked: this.checkIsBookmarked() })
    await this.initializeCommands(userProfile)
    this.mobileMediaQuery = window.matchMedia("(max-width: 768px)");
    this.mobileMediaQuery.addEventListener("change", this.onMobileViewChange);
  }

  componentWillUnmount() {
    this.mobileMediaQuery?.removeEventListener("change", this.onMobileViewChange);
  }

  mobileMediaQuery: MediaQueryList | undefined;

  onMobileViewChange(event: MediaQueryListEvent) {
    this.setState({ IsMobileView: event.matches, IsHoverPanelDisplayed: false });
  }

  openMobileHoverPanel() {
    this.setState({ IsHoverPanelDisplayed: true });
  }

  closeMobileHoverPanel() {
    this.setState({ IsHoverPanelDisplayed: false });
  }

  async componentDidUpdate(prevProps: Readonly<Search_ResultProps>, prevState: Readonly<Search_ResultStates>, snapshot?: any): Promise<void> {
    const { data, userProfile } = this.props
    if (prevProps.data.Id !== data.Id || prevProps.userProfile?.loginName !== userProfile?.loginName) {
      this.setState({ IsBookmarked: this.checkIsBookmarked()})
      await this.initializeCommands(userProfile)
    }
  }

  initializeCommands = async (userProfile: IUserProfile | undefined) => {
    if (!!userProfile) {
      const isAdmin = !!this.checkShowAdminCommands();
      const isNormal = await this.checkShowNormalCommands();
      this.setState({
        HasPermission: isAdmin || isNormal,
        Commands: isAdmin && this.adminCommands || isNormal && this.normalCommands || this.noAccessCommands
      }, () => {
        if (!!userProfile.permissions?.isSuperAdmin)
          this.setState({
            Commands: [...this.state.Commands,
            {
              key: Constants.COMMANDS.Delete,
              name: Constants.COMMANDS.Delete,
              iconProps: { iconName: "PageRemove" },
              onClick: () => this.handleCommand(Constants.COMMANDS.Delete),
            }]
          })
      })
    }
  }

  render() {
    let fileIcon = null;
    switch (this.state.HasPermission) {
      case true:
        fileIcon = (
          this.state.IsDownloading ? <RbLoadingSpinner /> :
            <span
              className="search-document-icon rb-ic rb-ic-document-pdf pointer"
              onClick={this._downloadFile}
            />
        );
        break;
      case false:
        fileIcon = (
          <span
            className="search-document-icon rb-ic rb-ic-lock-closed pointer"
            onClick={this._askToRequestPermission}
          />
        );
        break;
      case null:
        fileIcon = <RbLoadingSpinner />;
        break;
    }


    let searchItem = this.props.data

    let element = (
      <div className="ms-Grid" style={{ marginTop: 16, marginBottom: 10 }}>
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12"
            style={{ paddingLeft: "0px" }}
            onMouseOver={() => { if (!this.state.IsMobileView) this.showHoverPanel(true, "item"); }}
            onMouseLeave={() => { if (!this.state.IsMobileView) this.showHoverPanel(false, "item"); }}
          >
            <div className="ms-Grid">
              <div className="hover-white-blue">
                {/* Icon */}
                <div
                  className="search-result-icon-cell"
                  style={{
                    display: "table-cell",
                    width: "1px",
                    padding: "0px 10px",
                    verticalAlign: "top",
                  }}
                >
                  {fileIcon}
                </div>
                {/* Title and Authors */}
                <div className="search-result-content-cell" style={{ display: "table-cell" }} ref={this.state.ItemRef}>
                  <div className="ms-Grid">
                    <div className="ms-Grid-row">
                      <div
                        className="ms-Grid-col ms-sm8 search-result-title-col"
                        style={{ paddingLeft: "20px" }}
                      >
                        <div className="truncate search-result-title">
                          <RbLabel
                            className="pointer"
                            isInline={false}
                            isMultipleLines={false}
                            style={{ color: BoschColor.bosch_light_blue }}
                            onClick={() => Helper.openAMPage(searchItem.Id)}
                          >
                            {searchItem.Title}
                          </RbLabel>
                        </div>
                        {!!searchItem.Authors && Template.renderPeopleTextInlineTemplate(searchItem.Authors,
                          Helper.setEmptyStringIfUndefined(searchItem.AuthorDisplayName)
                        )}
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2 search-result-date-col"
                        style={{ textAlign: "left" }}
                      >
                        <RbLabel size={LabelSize.Small} isInline={false}>
                          {!_.isNil(searchItem.DocumentDate)
                            ? Helper.getDateTimeFormatForUI(
                              searchItem.DocumentDate,
                              true
                            )
                            : ""}
                        </RbLabel>
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2 search-result-actions-col"
                        style={{ textAlign: "right" }}
                      >
                        <span
                          className="search-action-icon search-mobile-info-icon rb-ic rb-ic-info-i-frame"
                          title="Details"
                          onClick={this.openMobileHoverPanel}
                        />
                        <span
                          className="search-action-icon rb-ic rb-ic-back-menu-mirror"
                          title="Forward"
                          onClick={() => this.forwardEmail()}
                        />
                        {this.state.IsBookmarked === true ? (
                          <span
                            className="search-action-icon rb-ic rb-ic-wishlist-full-yellow"
                            title="Remove Bookmark"
                            onClick={this.openRemoveBookmarkDialog}
                          />
                        ) : (
                          <span
                            className="search-action-icon rb-ic rb-ic-wishlist"
                            title="Bookmark"
                            onClick={this.addBookmark}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ms-Grid-col ms-sm4">
            {/* Hover Panel: desktop shows it as an anchored Callout next to
                the item; mobile has no hover, so tapping the info icon
                above opens the SAME content as a full-screen slide-in panel
                (consistent with the refinement/expert mobile panels)
                instead of a small overlapping Callout. */}
            {!this.state.IsMobileView ? (
              <Callout
                style={{ width: "28vw", maxWidth: "28vw" }}
                hidden={this.state.IsHoverPanelDisplayed === false}
                target={this.state.ItemRef.current}
                directionalHint={DirectionalHint.leftCenter}
                onMouseOver={() => this.showHoverPanel(true, "panel")}
                onMouseLeave={() => this.showHoverPanel(false, "panel")}
              >
                <Search_HoverPanel searchItem={searchItem} />
                {!_.isNil(this.state.HasPermission) ? (
                  <div className="search-result-command-buttons">
                    {this.renderCommandButtons(this.state.Commands)}
                  </div>
                ) : (
                  ""
                )}
              </Callout>
            ) : (
              <div
                className={"search-hover-fullpanel" + (this.state.IsHoverPanelDisplayed ? " open" : "")}
              >
                <button
                  type="button"
                  className="search-mobile-panel-close"
                  aria-label="Close details"
                  onClick={this.closeMobileHoverPanel}
                >
                  <span className="rb-ic rb-ic-close" />
                </button>
                <Search_HoverPanel searchItem={searchItem} />
                {!_.isNil(this.state.HasPermission) ? (
                  <div className="search-result-command-buttons">
                    {this.renderCommandButtons(this.state.Commands)}
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
    return element;
  }

  updateLLReferenceNumber = (newReferenceNumber: string) => {
    this.props.updateLLReferenceNumber({ reportId: this.props.data.Id, llReferenceNumber: newReferenceNumber }); // Dispatch action to update Redux store
  };

  renderCommandButtons(arraycommands: any[]) {
    if (this.props.data.UploadType === Constants.UPLOAD_TYPE.LL) {
      arraycommands = [...arraycommands, this.exportLessonsButton]
    }
    return arraycommands.map((items, index) => {
      return (
        <RbButton
          key={index}
          label={items.name}
          style={{ padding: "0.5rem 1rem", minWidth: "inherit", margin: "0px" }}
          type={ButtonType.Tertiary}
          onClick={() => {
            items.onClick();
          }}
        />
      );
    });
  }

  normalCommands = [
    {
      key: Constants.COMMANDS.View,
      name: Constants.COMMANDS.View,
      iconProps: { iconName: "EntryView" },
      onClick: () => this.handleCommand(Constants.COMMANDS.View),
    },
    {
      key: Constants.COMMANDS.CopyLink,
      name: Constants.COMMANDS.CopyLink,
      iconProps: { iconName: "Copy" },
      onClick: () => this.handleCommand(Constants.COMMANDS.CopyLink),
    },
  ];

  adminCommands = [
    ...this.normalCommands,
    {
      key: Constants.COMMANDS.Edit,
      name: Constants.COMMANDS.Edit,
      iconProps: { iconName: "PageEdit" },
      onClick: () => this.handleCommand(Constants.COMMANDS.Edit),
    },
    // {
    //   key: Constants.COMMANDS.Delete,
    //   name: Constants.COMMANDS.Delete,
    //   iconProps: { iconName: "PageRemove" },
    //   onClick: () => this.handleCommand(Constants.COMMANDS.Delete),
    // },
    {
      key: Constants.COMMANDS.Move,
      name: Constants.COMMANDS.Move,
      iconProps: { iconName: "FabricMovetoFolder" },
      onClick: () => this.handleCommand(Constants.COMMANDS.Move),
    },
  ];

  noAccessCommands = [
    {
      key: Constants.COMMANDS.RequestPermission,
      name: Constants.COMMANDS.RequestPermission,
      iconProps: { iconName: "FileComment" },
      onClick: () => this.handleCommand(Constants.COMMANDS.RequestPermission),
    },
    {
      key: Constants.COMMANDS.CopyLink,
      name: Constants.COMMANDS.CopyLink,
      iconProps: { iconName: "Copy" },
      onClick: () => this.handleCommand(Constants.COMMANDS.CopyLink),
    },
  ];

  exportLessonsButton = {
    key: "ExportLessons",
    name: "Export Lessons",
    iconProps: {
      iconName:
        "Export", // Exported
    },
    onClick: () => this.handleCommand(Constants.COMMANDS.ExportLL),
  }

  checkShowAdminCommands() {
    const { UploadType, Division } = this.props.data
    if (!!UploadType && !!Division)
      return Helper.checkHasPermissionOnDestination(UploadType, Division, this.props.userProfile);
    return false;
  }

  checkPermissionInSessionStorage() {
    let checkSession = Helper.getDecryptedSessionStorageWithExpiry(this.props.userProfile?.id + "_" + this.props.data.Id, this.props.userProfile?.id!);
    console.log("checkSession", checkSession);
    return !_.isNil(checkSession);
  }

  checkAccess = async () => {
    try {
      const response = await checkAccessibleReport(
        this.props.data.Id
      )
      const isAccessible = response.data.isAccessible
      if (!!isAccessible) {
        Helper.setEncryptedSessionStorageWithExpiry(
          this.props.userProfile?.id + "_" + this.props.data.Id,
          JSON.stringify({ Result: !!isAccessible }), 60 * 10,
          this.props.userProfile?.id!);
        return true;
      }
      return false;
    }
    catch {
      return false
    }
  }

  async checkShowNormalCommands() {
    // RnD, LL, Thesis, Paper is SC1
    if (
      this.props.data.UploadType === Constants.UPLOAD_TYPE.LL ||
      this.props.data.UploadType === Constants.UPLOAD_TYPE.Paper ||
      (this.props.data.SecurityClass ===
        Constants.SECURITY_CLASS_SHORT_NAME.SC1 &&
        (this.props.data.UploadType === Constants.UPLOAD_TYPE.RnD ||
          this.props.data.UploadType === Constants.UPLOAD_TYPE.Thesis))
    ) {
      return true;
    } else {
      // Thesis SC2 or RnD SC2/SC3
      let hasAccess = this.checkPermissionInSessionStorage();
      if (!!hasAccess) {
        return hasAccess;
      }
      return this.checkAccess()
    }
  }

  showHoverPanel(status: any, component: any) {
    if (status === true) {
      if (component === "panel") {
        this.state.HoverStatuses.panel = true;
        if (this.state.HoverStatuses.item === false) {
          if (this.state.IsHoverPanelDisplayed === false) {
            this.setState({
              IsHoverPanelDisplayed: true,
            });
          }
        }
      } else {
        // item
        this.state.HoverStatuses.item = true;
        if (this.state.HoverStatuses.panel === false) {
          if (this.state.IsHoverPanelDisplayed === false) {
            this.setState({
              IsHoverPanelDisplayed: true,
            });
          }
        }
      }
    } else {
      Helper.runNewTask(() => {
        if (component === "panel") {
          this.state.HoverStatuses.panel = false;
          if (this.state.HoverStatuses.item === false) {
            this.setState({
              IsHoverPanelDisplayed: false,
            });
          }
        } else {
          // item
          this.state.HoverStatuses.item = false;
          if (this.state.HoverStatuses.panel === false) {
            this.setState({
              IsHoverPanelDisplayed: false,
            });
          }
        }
      });
    }
  }

  async handleCommand(command: string, param: any = null) {
    switch (command) {
      case Constants.COMMANDS.View: {
        Helper.openAMPage(this.props.data.Id)
        break;
      }
      case Constants.COMMANDS.Edit: {
        Helper.openAMPage(`${this.props.data.Id}/${Constants.ACCESS_MEDIATOR_MODE.EDIT}`)
        break;
      }
      case Constants.COMMANDS.Move: {
        Helper.openNewTab(`${process.env.REACT_APP_MOVE_SINGLE}/${this.props.data.Id}`)
        break;
      }
      case Constants.COMMANDS.Delete: {
        await this.closeDeleteReportDialog();
        break;
      }
      case Constants.COMMANDS.CopyLink: {
        // Get link
        let link =
          this.props.data.AccessMediatorPath;
        // Copy link
        if (!_.isUndefined(link)) {
          const el = document.createElement("textarea");
          el.style.position = "fixed";
          el.value = link;
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
          this.props.showToastMessage(
            Constants.TOAST_MESSAGE_CODE.SUCCESS,
            Constants.SEARCH_MESSAGE.COPY_LINK.replace(
              "{0}",
              this.props.data.Title
            )
          );
        }
        else this.props.showToastMessage(
          Constants.TOAST_MESSAGE_CODE.ERROR,
          "Invalid Link"
        );
        break;
      }
      case Constants.COMMANDS.RequestPermission: {
        Helper.openAMPage(this.props.data.Id)
        break;
      }
      case Constants.COMMANDS.ExportLL: {
        // Exported
        const { LlreferenceNumber } = this.props.data
        let isExported = !!LlreferenceNumber;
        this.props.confirmDialog(
          Constants.CONFIRMATION_MESSAGE.EXPORT_LESSONS.TITLE,
          isExported === true
            ? Constants.CONFIRMATION_MESSAGE.EXPORT_LESSONS.CF_EXPORT_AGAIN.replace(
              "{0}",
              this.props.data.Title
            ).replace("{1}", LlreferenceNumber?.toString() ?? "")
            : Constants.CONFIRMATION_MESSAGE.EXPORT_LESSONS.CONTENT.replace(
              "reportTitle",
              this.props.data.Title
            ),
          false,
          () => {
            this.closeExportLLDialog();
          }
        );
        break;
      }
      default: {
        break;
      }
    }
    // Close hover panel after the action
    this.setState({
      IsHoverPanelDisplayed: false,
      HoverStatuses: {
        item: false,
        panel: false,
      },
    });
  }

  private _downloadFile() {
    !this.state.IsDownloading
      && this.props.showToastMessage(Constants.TOAST_MESSAGE_CODE.INFO, `Prepare downloading ${this.props.data.Title ?? ""}... Please wait`)
      && this.setState({
        IsDownloading: true
      }, () => {
        let name = Helper.generateNameFileForDownload(this.props.data.Title, this.props.data?.DocumentNumber ?? "")
        downloadReport(this.props.data.Id, Helper.generateBlobName(this.props.data.Guid), name).then((isSuccess) => {
          !!isSuccess &&
            Helper.runNewTask(async () => {
              const downloadedStatisticRecord: IDownloadedStatistic = {
                reportGuid: this.props.data.Guid,
                department: this.props.userProfile?.department || "",
                division: this.props.userProfile?.division || "",
                createdBy: this.props.userProfile?.name || "",
                securityClass: this.props.data.SecurityClass
              }
              await insertStatisticData(StatisticType.Downloaded, downloadedStatisticRecord)
            })
          this.setState({ IsDownloading: false }, () => {
            this.props.showToastMessage(!isSuccess ? ToastMessageCode.ERROR : ToastMessageCode.SUCCESS, !isSuccess ? "File not found" : "Download Successfully");
          });
        })
      })
  }

  private _askToRequestPermission() {
    this.props.confirmDialog(
      `You have no permission on document: ${this.props.data.Title}`,
      "Would you like to order this document ?", false,
      () => {
        Helper.openAMPage(this.props.data.Id)
      }
    );
  }

  async forwardEmail() {
    let currentData = this.props.data;
    this.props.confirmDialog(`Preparing mail content for ${currentData.Title}...`, "Once finished, your mail app will open right away.", true);
    let authorDisplayNames = !!currentData.Authors && currentData.Authors.length > 0 ? await getDisplayNameOfUsers(currentData.Authors) : []
    window.location.href =
      "mailto:?" +
      "subject=%5BFEBER%5D Recommended Report" +
      "&body=Hi,%0D%0A%0D%0AThe sender of this message would like to recommend a report from FEBER, the Bosch wide database for research and development reports.%0D%0A" +
      "Kindly access the recommended report which might be interesting to you.%0D%0A%0D%0A" +
      "Title: " +
      currentData.Title +
      " %0D%0A" +
      "Report Author(s): " +
      Helper.mergeAuthors(authorDisplayNames, currentData.AuthorDisplayName ?? "") +
      " %0D%0A" +
      "Date of Document: " +
      (!_.isNil(currentData.DocumentDate)
        ? Helper.getDateTimeFormatForUI(currentData.DocumentDate)
        : "") +
      " %0D%0A" +
      "Security Class: " +
      currentData.SecurityClass +
      " %0D%0A" +
      "Report Path: " +
      `${currentData.AccessMediatorPath ?? ""}`;
  }

  addBookmark() {
    if (this.state.IsAddingBookmark === false) {
      this.setState({ IsAddingBookmark: true }, async () => {
        try {
          let isAdded = await addBookmark(this.props.data.Id, this.props.userProfile?.loginName!)
          if (isAdded === true) {
            this.props.showToastMessage(
              Constants.TOAST_MESSAGE_CODE.SUCCESS,
              Constants.BOOKMARK_MESSAGE.CREATE.SUCCESS.replace(
                "{0}",
                this.props.data.Title
              )
            );
          } else {
            this.props.showToastMessage(
              Constants.TOAST_MESSAGE_CODE.ERROR,
              Constants.BOOKMARK_MESSAGE.CREATE.FAILED.replace(
                "{0}",
                this.props.data.Title
              )
            );
          }
          this.setState({
            IsAddingBookmark: false,
            IsBookmarked: true,
          }, () => {
            Helper.addBookmarkSessionStorage(Number.parseInt(this.props.data.Id))
          });
        } catch (error) {
          this.props.showToastMessage(
            Constants.TOAST_MESSAGE_CODE.ERROR,
            Constants.BOOKMARK_MESSAGE.CREATE.FAILED.replace(
              "{0}",
              this.props.data.Title
            )
          );
          this.setState({
            IsAddingBookmark: false,
          });
        }
      });
    }
  }

  openRemoveBookmarkDialog() {
    this.props.confirmDialog(
      Constants.CONFIRMATION_MESSAGE.REMOVE_BOOKMARK.TITLE,
      Constants.CONFIRMATION_MESSAGE.REMOVE_BOOKMARK.CONTENT.replace(
        "{0}",
        this.props.data.Title
      ),
      false,
      () => {
        this.removeBookmark();
      }
    );
  }

  async removeBookmark() {
    this.props.showDialog(Constants.DIALOG_MESSAGE.REMOVE_BOOKMARK);
    try {
      let isRemoved = await removeMyBookmark(this.props.data.Id ?? -1);
      if (isRemoved === true) {
        this.props.showToastMessage(
          Constants.TOAST_MESSAGE_CODE.SUCCESS,
          Constants.BOOKMARK_MESSAGE.REMOVE.SUCCESS.replace(
            "{0}",
            this.props.data.Title
          )
        );
      } else {
        this.props.showToastMessage(
          Constants.TOAST_MESSAGE_CODE.ERROR,
          Constants.BOOKMARK_MESSAGE.REMOVE.FAILED.replace(
            "{0}",
            this.props.data.Title
          )
        );
      }
      this.setState({
        IsBookmarked: false
      }, () => {
        Helper.removeBookmarkSessionStorage(Number.parseInt(this.props.data.Id))
      });
      this.props.showDialog(false);
    } catch (error) {
      this.props.showToastMessage(
        Constants.TOAST_MESSAGE_CODE.ERROR,
        Constants.BOOKMARK_MESSAGE.REMOVE.FAILED.replace(
          "{0}",
          this.props.data.Title
        )
      );
      this.props.showDialog(false);
    }
  }



  async closeExportLLDialog() {
    this.props.showDialog(`${this.props.data.Title} is processing...`)
    try {
      const exportLL = await exportLLDocument(this.props.data.Id);
      if (!!exportLL && exportLL.success && !!exportLL.data.llReferenceNumber) {
        this.props.confirmDialog(`Export ${this.props.data.Title} successfully`, `The document has been exported. New reference number is ${exportLL.data.llReferenceNumber}`, true, () => {
          this.updateLLReferenceNumber(exportLL.data.llReferenceNumber)
        })
      }
      else {
        this.props.confirmDialog(`Could not export ${this.props.data.Title}`, `${!!exportLL.message ? exportLL.message + " - " : ""}${Constants.MESSAGE_CONTACT_MAILBOX}`, true)
      }
    } catch (error) {
      this.props.confirmDialog(`Could not export ${this.props.data.Title}`, Constants.MESSAGE_CONTACT_MAILBOX, true)
    }
    finally {
      this.props.showDialog(false)
    }
  }

  async closeDeleteReportDialog() {
    this.props.confirmDialog(
      Constants.CONFIRMATION_MESSAGE.DELETE_REPORT.TITLE,
      Constants.CONFIRMATION_MESSAGE.DELETE_REPORT.CONTENT.replace(
        "{0}",
        this.props.data.Title
      ),
      false,
      () => {
        this.props.showDialog(Constants.DIALOG_MESSAGE.DELETE);
        this.props.deleteReportDispatch(
          this.props.data.Id,
          (rs: boolean) => {
            this.props.showDialog(false);
            this.props.confirmDialog(
              Constants.REPORT_MESSAGE.REMOVE.TITLE,
              (rs === true
                ? Constants.REPORT_MESSAGE.REMOVE.SUCCESS
                : Constants.REPORT_MESSAGE.REMOVE.FAILED
              ).replace("{0}", this.props.data.Title),
              true,
              () => { }
            );
          }
        );
      }
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps, {
  confirmDialog,
  showDialog,
  showToastMessage,
  deleteReportDispatch,
  updateLLReferenceNumber // Add this
})(Search_Result);

